export default __webpack_public_path__ + "media/php.5cb43e85.svg";